module.exports = __webpack_public_path__ + "img/ticket-search_active.590f3cc7.png";